export default __webpack_public_path__ + "static/media/Pyramide-besoins_perso_n2_securite.6a921423.svg";